import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function YasamKalitesiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['yasam-kalitesi-testi']} />;
}
